import { ScheduleGroupResponseTypes } from "backend";
import { Requests } from "../common/request.common";
import { post, postEmpty } from "./common";

export const scheduleGroup = {
    record(data: typeof Requests.ScheduleGroup.Record.Input) {
        return post<typeof data, ScheduleGroupResponseTypes.Record>("/schedule-group/record", data);
    },
    create(data: typeof Requests.ScheduleGroup.Create.Input) {
        return post<typeof data>("/schedule-group/create", data);
    },
    update(id: string, data: typeof Requests.ScheduleGroup.Update.Input) {
        return post<typeof data>(`/schedule-group/update/${id}`, data);
    },
    delete(id: string) {
        return postEmpty(`/schedule-group/delete/${id}`);
    },
};
